import { Spinner, Wrapper } from 'components';
import styles from './styles.module.scss';
import { PageWrapper } from 'pages/Workshop/PageWrapper';
import { FormsTable } from '../FormsTable';
import { FormTabs } from '../FormTabs';
import { useSelector } from 'react-redux';
import { getProjectFilterSelector } from 'store/selectors/transactions';
import {
  getAllFormProcessesSelector,
  getFormsFiltersSelector,
} from 'store/selectors/requestFormProcess';
import { prepareFormsDataSource } from '../FormsTable/helper';
import { useMemo } from 'react';

export const FormsContent = (props) => {
  const { isPending, showListView, justSignedFormProcessPublicId } = props;
  const allFormsData = useSelector(getAllFormProcessesSelector);

  const formCategoryFilter = useSelector(getProjectFilterSelector);
  const { search } = useSelector(getFormsFiltersSelector);

  const formsData = useMemo(
    () =>
      prepareFormsDataSource(
        allFormsData,
        formCategoryFilter,
        justSignedFormProcessPublicId,
        search,
      ),
    [search, formCategoryFilter, allFormsData],
  );

  if (isPending) return <Spinner loaderClassName={styles.loader} />;

  if (showListView) {
    return (
      <PageWrapper className={styles.formPageWrapper} isHideFooter isContainer={false}>
        <Wrapper isPending={isPending}>
          <FormsTable {...props} formsData={formsData} />
        </Wrapper>
      </PageWrapper>
    );
  }

  return (
    <div className={styles.formsContent}>
      <FormTabs {...props} formsData={formsData} />
    </div>
  );
};
